import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let LabelValueComp;

class Label_value_pair extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: LabelValueComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/zcat-components/label-value-comp" */
      "../../../components/javascript/zcat-components/label-value-comp"
    ).then(function(res) {
      LabelValueComp = res.LabelValueComp;
    }));

    
;
  }
}

export { Label_value_pair };
